import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Upload Stroke
 */

export default function UploadStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M7.49999 11.5C7.49999 11.7761 7.72385 12 7.99999 12C8.27613 12 8.49999 11.7761 8.49999 11.5L8.49999 3.88103L10.1159 5.82009C10.2927 6.03223 10.6079 6.06089 10.8201 5.88411C11.0322 5.70733 11.0609 5.39205 10.8841 5.17991L8.3841 2.17991C8.2891 2.06591 8.14838 2 7.99999 2C7.8516 2 7.71087 2.06591 7.61588 2.17991L5.11588 5.17991C4.9391 5.39205 4.96776 5.70733 5.1799 5.88411C5.39203 6.06089 5.70732 6.03223 5.8841 5.82009L7.49999 3.88103L7.49999 11.5ZM2.5 9C2.5 8.72386 2.27614 8.5 2 8.5C1.72386 8.5 1.5 8.72386 1.5 9V15C1.5 15.2761 1.72386 15.5 2 15.5H14C14.2761 15.5 14.5 15.2761 14.5 15V9C14.5 8.72386 14.2761 8.5 14 8.5C13.7239 8.5 13.5 8.72386 13.5 9V14.5H2.5V9Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
